
export const toggleLayerState = (layerId) => {
    return {
        type: 'TOGGLE_LAYER_STATE',
        payload: {layerId}
    }
};

export const changeMapZoom = (zoom) => {
    return {
        type: 'CHANGE_ZOOM',
        payload: zoom
    }
}

export const updateSld = (layerId, sldBody, styleData) => {
    return {
        type: 'UPDATE_SLD',
        payload: {layerId, sldBody, styleData}
    }
}

export const changeColorRamp = (colorRamp) => {
    return {
        type: "CHANGE_COLORRAMP",
        payload: colorRamp
    }
}

export const setActiveField = (field) => {
    return {
        type: "SET_ACTIVE_FIELD",
        payload: field
    }
}

export const updateBms = (bmIds) => {
    return {
        type: "UPDATE_BMS",
        payload: bmIds
    }
}

export const setSecondLayerEnabled = (enabled) => ({
    type: "SET_SECOND_LAYER_ENABLED",
    payload: enabled
});

export const setSecondLayerSource = ({ layerId, field }) => ({
    type: "SET_SECOND_LAYER_SOURCE",
    payload: { layerId, field }
});

export const setSecondLayerStyle = (styleData) => ({
    type: "SET_SECOND_LAYER_STYLE",
    payload: styleData
});

export const setSecondLayerSld = ({ sldBody, sldId }) => ({
    type: "SET_SECOND_LAYER_SLD",
    payload: { sldBody, sldId }
});

export const setSecondLayerOpacity = (opacity) => ({
    type: "SET_SECOND_LAYER_OPACITY",
    payload: opacity
});
